import type { ColorScheme, ColorTheme } from "@/app/theme";
import { api } from "@/shared/api/client";
import type { Season } from "@/shared/api/types";

export type ContentSettings = {
	activeSeason: Season;
	cardColorScheme: ColorScheme;
	cardColorTheme: ColorTheme;
	seasonSwitch: boolean;
};

export const contentSettingsKey = ["admin", "content", "settings"] as const;

export async function getContentSettings(): Promise<ContentSettings> {
	return api.get("admin/content/settings").json();
}

export async function updateContentSettings(input: {
	activeSeason: Season;
	cardColorScheme?: ColorScheme;
	cardColorTheme?: ColorTheme;
	seasonSwitch?: boolean;
}): Promise<ContentSettings> {
	return api.patch("admin/content/settings", { json: input }).json();
}

export function nextSeason(season: Season): Season {
	return season === "winter" ? "summer" : "winter";
}

export function contentSettingsPatch(
	current: ContentSettings,
	patch: Partial<ContentSettings>,
): ContentSettings {
	return {
		activeSeason: patch.activeSeason ?? current.activeSeason,
		cardColorScheme: patch.cardColorScheme ?? current.cardColorScheme,
		cardColorTheme: patch.cardColorTheme ?? current.cardColorTheme,
		seasonSwitch: patch.seasonSwitch ?? current.seasonSwitch,
	};
}
